module.exports = __webpack_public_path__ + "908e4d2e/img/at-icon.5d6fc5d8.svg";